export const PROJECT_REGENERATION_POLL_ID =
  'app/project/project-regeneration-poll-id';

export const PROJECT_NAME_GENERATION_POLL_ID =
  'app/project/project-name-generation-poll-id';
